import type { PrimaryFilterId } from '../../../filters/types/filters';
import { ChartFallback } from '../../Chart/ChartFallback';
import type {
  DataProviderChildren,
  SingleDataSet,
  TimeseriesDataSet,
} from '../types';
import { computeDemandSupplyDataSetOrTimeseries } from './market-condition-metrics-utils';
import { useCompositionAndPostingsQueries } from './useCompositionAndPostingsQueries';

export type DemandSupplyData = SingleDataSet | TimeseriesDataSet | undefined;

export const DemandSupplyDataProvider = ({
  primaryDimension,
  variant = 'ratio',
  children,
}: {
  primaryDimension: PrimaryFilterId;
  variant?: 'ratio' | 'percentile';
  children: DataProviderChildren<DemandSupplyData>;
}) => {
  const { compositionData, monthRefs, postingsData, status } =
    useCompositionAndPostingsQueries(primaryDimension);

  const getData = (): DemandSupplyData => {
    if (!compositionData || !postingsData) return undefined;
    return computeDemandSupplyDataSetOrTimeseries(
      compositionData,
      postingsData,
      variant,
      monthRefs
    );
  };

  const data = getData();

  return (
    <ChartFallback status={status}>{children({ data, status })}</ChartFallback>
  );
};
